import { DeleteButton, Toolbar } from 'react-admin';
import AddInvoiceButton from './AddInvoiceButton';
import { ContractSaveButton } from './ContractSaveButton';
import DisplayContractButtons from './DisplayContractButtons';

const ContractEditToolBar = () => {
  return (
    <Toolbar>
      <ContractSaveButton />
      {/* <DisplayContractButtons source="id" /> */}
      {/* <AddInvoiceButton /> */}
      <DeleteButton label="Delete" sx={{ marginLeft: 'auto' }} />
    </Toolbar>
  );
};

export default ContractEditToolBar;
